import { Notify } from "vant";
import {
  gasPrice,
  isChainId,
  getAccountAddress,
  getWriteWeb3,
  getReadWeb3,
} from "../index";

const CANCELLED_MESSAGE = "已取消交易";
const FAILED_MESSAGE = "交易失败";

function logTransactionError(err) {
  const detail =
    err?.message ||
    err?.reason ||
    err?.data?.message ||
    err;
  console.error("[交易失败]", detail, err);
}

export function isTransactionCancelledError(err) {
  if (!err) return false;
  if (err.isCancelled) return true;

  const code = err.code ?? err?.data?.code;
  if (
    code === 4001 ||
    code === "4001" ||
    code === "ACTION_REJECTED" ||
    code === -32603 && String(err.message || "").toLowerCase().includes("user denied")
  ) {
    return true;
  }

  const message = String(
    err.message || err.reason || err?.data?.message || ""
  ).toLowerCase();

  const cancelledPatterns = [
    "user denied",
    "user rejected",
    "rejected the request",
    "request rejected",
    "action_rejected",
    "cancelled",
    "canceled",
    "declined",
    "aborted",
  ];

  return cancelledPatterns.some((pattern) => message.includes(pattern));
}

export function assertWalletReady() {
  const accountAddress = getAccountAddress();
  if (!accountAddress) {
    throw new Error("请先连接钱包");
  }
  if (!isChainId) {
    throw new Error("请切换到 BSC 主网");
  }
  const web3 = getWriteWeb3();
  if (!web3) {
    throw new Error("钱包未初始化");
  }
  return web3;
}

export async function sendContractMethod(method, { from } = {}) {
  assertWalletReady();
  const sender = from || getAccountAddress();
  try {
    const gas = await method.estimateGas({ from: sender });
    const receipt = await method.send({
      from: sender,
      gas: Math.floor(Number(gas) * 1.2),
      gasPrice,
    });
    return receipt;
  } catch (err) {
    if (isTransactionCancelledError(err)) {
      Notify({ message: CANCELLED_MESSAGE });
      const cancelErr = new Error(CANCELLED_MESSAGE);
      cancelErr.isCancelled = true;
      throw cancelErr;
    }
    logTransactionError(err);
    Notify({ type: "danger", message: FAILED_MESSAGE });
    throw err;
  }
}

export function formatTokenAmount(value, decimals = 18, fractionDigits = 4) {
  const web3 = getWriteWeb3() || getReadWeb3();
  const normalized = web3.utils.fromWei(String(value), "ether");
  const num = Number(normalized);
  if (!Number.isFinite(num)) return "0";
  if (num === 0) return "0";
  return num.toFixed(fractionDigits).replace(/\.?0+$/, "");
}

export function parseTokenAmount(amount, decimals = 18) {
  const web3 = getWriteWeb3() || getReadWeb3();
  return web3.utils.toWei(String(amount), "ether");
}
